import { computed, useState } from "#imports";
import {
  getBreadcrumbFromRouteQuery
} from "./../../helpers/breadcrumb.js";
export function useBreadcrumb(v) {
  const state = useState("breadcrumbLinks", () => []);
  if (v === void 0) {
    return computed(() => state.value);
  } else if (Array.isArray(v)) {
    state.value = v;
  } else {
    state.value = getBreadcrumbFromRouteQuery(v);
  }
}
